import styled from '@emotion/styled';
import { colorPalettes, Flex, SPACES } from '@linearb/linui-common';
import { ReactComponent as CircleAlertUnstyled } from '../../../../images/icons/circle-alert.svg';

const StyledLoginUnsuccessful = styled(Flex)`
  align-items: center;
  justify-content: center;
  align-content: center;
  margin-top: ${SPACES['medium']};
  padding: 1rem 1.8rem;
  margin-right: ${SPACES['medium']};
  margin-left: ${SPACES['medium']};
  border-radius: 0.5rem;
  background-color: ${({ theme }) =>
    colorPalettes[theme.palette.mode].alert.warning.background};
`;

export const CircleAlert = styled(CircleAlertUnstyled)`
  padding-top: 0.1rem;
  fill: ${({ theme }) => colorPalettes[theme.palette.mode].alert.warning.text};
`;

export default StyledLoginUnsuccessful;
